import React from 'react';
import { Link } from 'react-router-dom';
import ROUTES from '../routes.json';
import { normalizeRoute } from '../utils/routeHelpers';

const RefundPolicy = () => {
  return (
    <div style={{padding:24}}>
      <h1 className="page-title">Refund Policy</h1>
      <div className="page-content" style={{ marginTop: 12, color: '#6b7280' }}>
        <p>
          Our Refund Policy explains how we approach refund requests for subscriptions and one-time purchases. We aim to be fair and transparent; refunds are considered based on the purchase type, timing, and the circumstances described in a request.
        </p>
        <p>
          If you believe you're eligible for a refund, please contact our billing team with your order details and a brief explanation. We will investigate and respond with next steps. Refunds are typically processed through the original payment provider.
        </p>
        <ul style={{ marginTop: 8 }}>
          <li>Refund requests reviewed case-by-case with clear communication.</li>
          <li>Processing depends on the payment provider’s timelines.</li>
          <li>Contact billing with order details for faster resolution.</li>
        </ul>
        <p style={{ marginTop: 12 }}>
          When requesting a refund, include your order number, the date of purchase, and a concise explanation of why you are requesting reimbursement. Our team evaluates each request promptly and communicates the outcome and any follow-up steps. Refunds that are approved will be processed through the original payment method; the timing of funds returning to your account depends on the payment processor and your bank.
        </p>
        <p>
          Certain purchases, such as those made under promotional conditions or with third-party vendors, may be subject to different refund rules. If you purchased through an app store or an external partner, check their refund policies as they may handle refunds directly.
        </p>
        <ul style={{ marginTop: 8 }}>
          <li>Provide order details and a clear reason to speed up review.</li>
          <li>Refunds are issued via the original payment channel when approved.</li>
          <li>Third-party purchases may be subject to vendor-specific policies.</li>
        </ul>
        <p style={{ marginTop: 12 }}>
          To make a refund request more efficient, attach receipts or screenshots and describe the issue concisely. Our billing team follows up with a clear timeline and next steps. Note that refund processing time depends on the payment processor and the customer's bank, so funds may not appear immediately after approval.
        </p>

        <p>
          Some purchases, including promotional credits or purchases through third parties, may follow different rules. If you used a platform store (e.g., an app marketplace), check their refund process as they sometimes handle refunds directly.
        </p>
      </div>

      <p>Last updated: {new Date().toISOString().split('T')[0]}</p>

      <p>We strive to keep our users satisfied. Refunds for paid subscriptions or one-time purchases will be handled on a case-by-case basis. In many cases payments are processed through Razorpay — please see their refund processing details at https://razorpay.com/docs/payments/faq/#refunds</p>

      <h3>How to request a refund</h3>
      <ol>
        <li>Email info.onehubtech@gmail.com with your payment details and reason for refund.</li>
        <li>We will review and respond within 5 business days.</li>
        <li>If applicable, we will issue refunds via the original payment method via Razorpay.</li>
      </ol>

      <h3>Contact</h3>
      <p>For refund questions: info.onehubtech@gmail.com</p>

      <div style={{ marginTop: 20 }}>
        <h4>Explore more</h4>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <Link to={normalizeRoute(ROUTES.humanizer.path)} className="btn ghost">Try the Humanizer</Link>
          <Link to={normalizeRoute(ROUTES.blog.path)} className="btn ghost">Visit our Blog</Link>
          <Link to={normalizeRoute(ROUTES.contact.path)} className="btn ghost">Contact Us</Link>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
